import React, { Component } from "react";

import CmsCompanies from "./CmsCompanies/CmsCompanies";
import CmsDevices from "./CmsDevices/CmsDevices";
import SideContentBlock from "../../shared/sideContentBlock";
import SideContentInner from "../../shared/sideContentInner";
import CmsUsers from "./CmsUsers/CmsUsers";
import styles from "./cmsPage.module.scss";
import { states } from "../../reducers/queriesStates";
import { withReprocessUnits } from "../../shared/containers/containerReprocessUnits";
import CmsReprocessUnits from "./CmsReprocesUnits/CmsReprocessUnits";
import CmsExceptions from "./CmsExceptions/CmsExceptions";
import CmsRetranslations from "./CmsRetranslations/CmsRetranslations";

class CmsPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tabIndex: 0,
    };
  }

  componentDidMount() {
    const { reprocessUnitsDataState, onGetReprocessUnits } = this.props;

    if (reprocessUnitsDataState === states.NOT_REQUESTED) {
      onGetReprocessUnits();
    }
  }

  getTabView() {
    const { tabIndex } = this.state;

    switch (tabIndex) {
      case 0:
        return <CmsCompanies />;
      case 1:
        return <CmsDevices devicePanelEnable={true} createPanel={true} />;
      case 2:
        return <CmsUsers />;
      case 3:
        return <CmsReprocessUnits />;
      case 4:
        return <CmsExceptions />;
      case 5:
        return <CmsRetranslations />;
      default:
        return null;
    }
  }

  setTabIndex(index) {
    this.setState({ tabIndex: index });
  }

  getTabs() {
    const { tabIndex } = this.state;
    const titles = ["Области владения компаниями", "Устройства", "Пользователи", "Повторная обработка", "Ошибки в системе", "Ретрансляции"];
    const { reprocessUnits, lastSchedulerTime } = this.props;

    const reprocessUnitsErrors = reprocessUnits.filter((x) => {
      return x.reprocessStatus > 4;
    });

    const color = new Date().getTime() - new Date(lastSchedulerTime).getTime() > 180000 ? "red" : null;

    return titles.map((item, index) => {
      return index === 3 ? (
        <div
          key={index}
          className={tabIndex === index ? styles.cmsTabActive : styles.cmsTab}
          onClick={this.setTabIndex.bind(this, index)}
          style={{ color: color }}
        >
          {item}
          {reprocessUnits.length > 0 ? (
            <div>
              <span>{reprocessUnits.length}</span>{" "}
              <span style={{ color: "red" }}>{reprocessUnitsErrors.length > 0 ? reprocessUnitsErrors.length + " с ошибкой" : null}</span>
            </div>
          ) : null}
        </div>
      ) : (
        <div key={index} className={tabIndex === index ? styles.cmsTabActive : styles.cmsTab} onClick={this.setTabIndex.bind(this, index)}>
          {item}
        </div>
      );
    });
  }

  render() {
    return (
      <SideContentBlock>
        <SideContentInner>
          <div className={styles.cmsTabsContainer}>{this.getTabs()}</div>
          <div className={styles.cmsPage}>{this.getTabView()}</div>
        </SideContentInner>
      </SideContentBlock>
    );
  }
}

export default withReprocessUnits(CmsPage);
